import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './index.css';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import BulkUpload from './pages/BulkUpload';
import HistoryPage from './pages/HistoryPage'; 
import CustomerHistory from './pages/CustomerHistory'; 
import OpenEye from './pages/OpenEye'; // Add this import

export default function App() {
  return (
    <BrowserRouter>
      {/* Toast Container must be rendered once in your app (usually at root) */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored" // Optional: try "dark" or "light"
      />
      
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/bulk-upload" element={<BulkUpload />} />
        <Route path="/history" element={<HistoryPage />} />
        <Route path="/history/:customerId" element={<CustomerHistory />} />
        <Route path="/openeye" element={<OpenEye />} /> {/* Add this route */}
      </Routes>
    </BrowserRouter>
  );
}